export const CheckCircleIcon = () => {
  return (
    <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.75065 14.1003L12.2507 17.6003L19.2507 10.6003M25.6673 14.1003C25.6673 20.5436 20.444 25.7669 14.0007 25.7669C7.55733 25.7669 2.33398 20.5436 2.33398 14.1003C2.33398 7.65694 7.55733 2.43359 14.0007 2.43359C20.444 2.43359 25.6673 7.65694 25.6673 14.1003Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
